import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {HeaderModule} from '../shared/header/header.module';
import {FooterModule} from '../shared/footer/footer.module';

import {FaqComponent} from './faq.component';

@NgModule({
    declarations: [ FaqComponent ],
    imports: [
        RouterModule.forChild([{ path: '', component: FaqComponent }]),
        CommonModule,
        HeaderModule,
        FooterModule
    ],
    exports: [ FaqComponent ]
})

export class FaqModule {}
